<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__schoolcalendarprimary}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.schoolCalendarName" placeholder="校历名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('schoolcalendar:schoolcalendarprimary:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('schoolcalendar:schoolcalendarprimary:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="schoolCalendarName" label="校历名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="year" label="学年" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.schoolYearName}}
          </template>
        </el-table-column>
        <el-table-column prop="termType" label="学期" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.termType === 0">上学期</el-tag>
            <el-tag type="warning" v-else-if="scope.row.termType === 1">下学期</el-tag>
          </template>
        </el-table-column>
        <el-table-column  label="校历时间范围" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.termStartTime}} 至 {{scope.row.termEndTime}}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deptName" label="学校" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isEnable" label="是否启用校历" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.isEnable === 0">不启用</el-tag>
            <el-tag type="success" v-else-if="scope.row.isEnable === 1">启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="350">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('schoolcalendar:schoolcalendarprimary:isEnable')" type="text" size="small" @click="isEnableHandle(scope.row.id,scope.row.isEnable)">
              <div v-if="scope.row.isEnable === 0">启用</div>
              <div v-else-if="scope.row.isEnable === 1">不启用</div>
            </el-button>
            <el-button v-if="$hasPermission('schoolcalendar:schoolcalendarprimary:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('schoolcalendar:schoolcalendarprimary:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './schoolcalendarprimary-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/schoolcalendar/schoolcalendarprimary/page',
        getDataListIsPage: true,
        deleteURL: '/schoolcalendar/schoolcalendarprimary',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    isEnableHandle (id, isEnable) {
      if (isEnable === 0) {
        isEnable = 1
      } else {
        isEnable = 0
      }
      this.$http.post('/schoolcalendar/schoolcalendarprimary/isEnable', { id: id, isEnable: isEnable }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('refreshDataList')
          }
        })
        this.getDataList()
      }).catch(() => {})
    }
  }
}
</script>
